// 1. PAYMENT METHOD TYPES
const PAYMENT_METHOD_TYPE = {
  ATM_BANK: 1,
  MOMO: 2,
  GTELPAY: 3,
  VNPAY: 4,
  ZALOPAY: 5,
  VIETTEL_PAY: 6,
};

// 9. EXPORTS
export { PAYMENT_METHOD_TYPE };